import React from 'react'
import styled from 'styled-components'
import { Button } from 'antd'

const Legend = styled.div`
  flex: 0 0 250px;
`
const Box = styled.div`
  width: 10px;
  height: 10px;
  padding-top: 1px;
  display: inline-block;
  margin-left: 2px;
  margin-right: 2px;
`

const LegendComponent = ({ /* value, */ color, flag, display, id, toggle }) => {
  const ColorBox = styled(Box)`
    background-color: ${color};
  `
  return (
    <Legend>
      <input type="checkbox" checked={flag} onChange={() => toggle(id)} />
      <ColorBox />
      {display}
    </Legend>
  )
}

const LegendPanel = ({
  selectAll,
  clearAll,
  keys,
  colorScale,
  flags,
  contentWidth,
  toggleFlag,
}) => {
  const LegendContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: ${contentWidth}px;
  `
  return (
    <div>
      <div>
        <Button onClick={selectAll} size="small">
          Select All
        </Button>
        <Button onClick={clearAll} size="small">
          Clear
        </Button>
      </div>
      <LegendContainer>
        {keys.map(({ id, display }) => (
          <LegendComponent
            key={id}
            display={display}
            id={id}
            color={colorScale(id)}
            flag={flags[id]}
            toggle={toggleFlag}
          />
        ))}
      </LegendContainer>
    </div>
  )
}

export default LegendPanel
